import { NotFoundState, Page } from '@kanos/web-core';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { HELP_ARTICLES } from '../help/articles';
import { faqOf, FaqList, faqQuery } from '../help/faq';

export const Route = createFileRoute('/help/$slug')({
  component: HelpArticlePage,
});

/** One help article: what an area is for and how it works, then the questions people ask. */
function HelpArticlePage() {
  const { slug } = Route.useParams();
  const navigate = useNavigate();
  const faq = useQuery(faqQuery);
  const article = HELP_ARTICLES.find((a) => a.slug === slug);
  if (!article) return <NotFoundState onHome={() => void navigate({ to: '/help' })} />;
  const questions = faqOf(faq.data ?? [], article.slug);
  return (
    <Page title={article.title} subtitle={article.summary}>
      <Link
        to="/help"
        className="inline-flex min-h-11 items-center gap-1 justify-self-start rounded-sm text-[0.9375rem] font-semibold text-accent-text outline-none focus-visible:outline-2 focus-visible:outline-focus"
      >
        <ChevronLeft aria-hidden className="size-4" />
        Alle Hilfeartikel
      </Link>
      {article.sections.map((section) => (
        <section
          key={section.heading}
          className="glass grid max-w-prose gap-3 rounded-lg p-5 sm:p-6"
        >
          <h2 className="text-lg font-semibold tracking-[-0.02em]">{section.heading}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph} className="text-[0.9375rem] leading-relaxed">
              {paragraph}
            </p>
          ))}
        </section>
      ))}
      {questions.length > 0 && (
        <section aria-labelledby="faq" className="grid gap-3">
          <h2 id="faq" className="text-lg font-semibold tracking-[-0.02em]">
            Häufige Fragen
          </h2>
          <FaqList entries={questions} />
        </section>
      )}
    </Page>
  );
}
